import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import AdminTableComponent from '../admin-table'
import { getUsers, generateReferralReport } from '../actions';
import UserEnabledCell from './cell-renderers/user-enabled-cell';
import ActionsCell from './cell-renderers/actions-cell';
import OwnerServiceFeeCell from './cell-renderers/owner-service-fee-cell';
import RenterServiceFeeCell from './cell-renderers/renter-service-fee-cell';
import { getOrder } from '../bookings/bookings-list-component';

const shortDateFormat = "MM/DD/YY";
const dateFormat = "MM/DD/YY hh:mm:ss"

const mapStateToProps = state => ({
  global: state.Global,
  users: state.Admin.users
});
const columns =
  [
    {
      Header: "User ID",
      accessor: "_id",
      disableSortBy: true
    },
    {
      Header: "Name",
      accessor: "fullNameAccessor",
      Cell: ({ data: user }) => user.fullName,
      CustomData: true

    },
    {
      Header: "Email",
      accessor: "email",
      disableSortBy: true
    },
    {
      Header: "Location",
      accessor: "fullAddress",
    },
    {
      Header: "Phone Number",
      accessor: "phoneNumber",
      disableSortBy: true
    },
    {
      Header: "User\nType",
      accessor: "userType"
    },
    {
      Header: "Sign-up\nDate",
      accessor: "rawCreatedDate",
      Cell: ({ data: user }) => user.niceCreatedDate,
      CustomData: true
    },
    {
      Header: "Last\nActive",
      accessor: "rawLastOnline",
      Cell: ({ data: user }) => user.niceLastOnline,
      CustomData: true
    },
    {
      Header: "Enabled",
      accessor: "isActive",
      Cell: (props) => (<UserEnabledCell {...props} />),
      CustomData: true
    },
    {
      Header: "Owner's\nFee",
      accessor: "serviceFees.ownerFee",
      Cell: (props) => (<OwnerServiceFeeCell {...props} />),
      CustomData: true
    },
    {
      Header: "Renter's\nFee",
      accessor: "serviceFees.renterFee",
      Cell: (props) => (<RenterServiceFeeCell {...props} />),
      CustomData: true
    },
    {
      Header: " ",
      accessor: d => d._id,
      disableSortBy: true,
      Cell: (props) => (<ActionsCell {...props} />)
    }
  ];

class UsersListComponent extends PureComponent {
  constructor(props) {
    super(props);
  }
  state = {
    currentSort: 'desc',
    columnSorted: 'createdDate',
    dataType: 'date',
    generatingReport: false
  };

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(getUsers());
  }

  generateReport = () => {
    this.setState({ generatingReport: true });
    this.props.dispatch(generateReferralReport(this.onReportGenerated));
  }
  onReportGenerated = () => {
    this.setState({
      generatingReport: false
    });
  }

  compareUsersPart = (a, b, columnSorted) => {
    let tempDate = '1900-01-01T00:00:00.000Z';

    if (columnSorted === 'addressCity') {
      try {
        if (a["address"] === undefined)
          a[columnSorted] = "z";
        else
          a[columnSorted] = a["address"]["city"];

        if (b["address"] === undefined)
          b[columnSorted] = "z";
        else
          b[columnSorted] = b["address"]["city"];
      } catch (e) { }
    }

    if (columnSorted === 'lastOnline') {
      if (a[columnSorted] === undefined)
        a[columnSorted] = tempDate
      if (b[columnSorted] === undefined)
        b[columnSorted] = tempDate
    }
  }

  compareUsers = (a, b) => {
    let { columnSorted } = this.state;
    let { currentSort } = this.state;
    let { dataType } = this.state;

    if (columnSorted === 'address.city')
      columnSorted = "addressCity"

    let dotCount = columnSorted.split(".").length - 1;

    this.compareUsersPart(a, b, columnSorted);

    var propertyA = null, propertyB = null;

    // no periods between properties
    if (dotCount === 0) {
      propertyA = a[columnSorted]
      propertyB = b[columnSorted];
      return getOrder(propertyA, propertyB, currentSort, dataType);
    }
    // 1 period between properties
    else if (dotCount === 1) {
      let str1 = columnSorted.substring(0, columnSorted.indexOf('.') );
      let str2 = columnSorted.substring(columnSorted.indexOf('.')+1);
      propertyA = a[str1][str2]
      propertyB = b[str1][str2];
      return getOrder(propertyA, propertyB, currentSort, dataType);
    }
    // 2 periods between properties
    else if (dotCount === 2) {
      let str1 = columnSorted.substring(0, columnSorted.indexOf('.') );
      let str2 = columnSorted.substring(columnSorted.indexOf('.')+1, columnSorted.lastIndexOf('.'));
      let str3 = columnSorted.substring(columnSorted.lastIndexOf('.') + 1);
      propertyA = a[str1][str2][str3];
      propertyB = b[str1][str2][str3];
      return getOrder(propertyA, propertyB, currentSort, dataType);
    }

    return 0;
  }

  onSort = (column, type) => {
    const { columnSorted, currentSort } = this.state;
    let nextSort = 'default';
    if (column === columnSorted) {
      if (currentSort === 'desc') nextSort = 'asc';
      else if (currentSort === 'asc') nextSort = 'desc';
      else if (currentSort === 'default') nextSort = 'desc';
    }
    else nextSort = 'desc';
    this.setState( {
      currentSort: nextSort, columnSorted: column, dataType: type
    } );
  }

  render() {
    let { users } = this.props;
    let orderedUsers = users.map(u => {

      u.fullNameAccessor = `${u.lastName} ${u.firstName}`;
      u.fullName = `${u.firstName} ${u.lastName}`;
      u.fullAddress = u.address ? `${u.address.city} ${u.address.state}` : "N/A";
      u.rawCreatedDate = moment(u.createdDate).valueOf();
      u.niceCreatedDate = moment(u.createdDate).format(shortDateFormat);

      if (u.isActive) {
        u.rawLastOnline = u.lastOnline ? moment(u.lastOnline).valueOf() : 0;
        u.niceLastOnline = u.lastOnline ? moment(u.lastOnline).format(dateFormat) : 'N/A'
      } else {
        u.rawLastOnline = -1;
        u.niceLastOnline = "Deactivated";
      }

      return u;
    }).sort(this.compareUsers);
    if (!users) return (<div className="container text-center"><h4>Loading...</h4></div>)

    return (<div>
      <div className="user-report-btn-container">
        {this.state.generatingReport
          ? <button className="btn-secondary" disabled={true}>Generating...</button>
          : <button className="btn-secondary" onClick={this.generateReport}>Referral Report <i className="fas fa-file-download" /></button>
        }

      </div>
      <AdminTableComponent columns={columns} data={orderedUsers} />
    </div>
    );

  }
}
export default withRouter(connect(mapStateToProps)(UsersListComponent));
